import { connect } from "react-redux";
import KeyTakeAways from "./KeyTakeAways";


const mapStateToProps = (state) => ({

    fetchTopStrengthAndTopDevApi: state.BenchmarkFilteringReducer.fetchTopStrengthAndTopDevApi

});

const mapDispatchToProps = (dispatch) => ({




});

export default connect(mapStateToProps, mapDispatchToProps)(KeyTakeAways);
